export enum GameLayoutTypes {
    Unknown = 0,
    Desktop = 1,
    Landscape = 2,
    Portrait = 3
}
